import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhiteCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM8.70711 14.2929C8.31658 14.6834 7.68342 14.6834 7.29289 14.2929L3.70549 10.7055C3.31586 10.3159 3.31586 9.68414 3.70549 9.29451C4.09474 8.90526 4.7257 8.90482 5.11549 9.29352L8 12.17L14.8804 5.28961C15.2719 4.89811 15.9074 4.89963 16.2975 5.29251C16.6857 5.68343 16.6849 6.31506 16.2954 6.70461L8.70711 14.2929Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgWhiteCheck);
export { ForwardRef as ReactComponent };
